module.exports = __webpack_public_path__ + "img/sp_article_14.e3a7c09f.jpg";